import React from 'react'

const ProblemSection = () => {
  return (
    <section className="section-padding bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">
          Why are small businesses blind to customer traffic?
        </h2>
        <div className="text-lg text-gray-600 space-y-6">
          <p>
            Most small and medium business owners rely on sales reports to judge how busy a day was. 
            But sales only show transactions — not how many people walked in, browsed, and left without buying.
          </p>
          <p>
            And if you run more than one location, you can't be everywhere at once. You don't really know 
            which shop is thriving and which is struggling until it's too late.
          </p>
          <p>
            Meanwhile, big retailers invest in enterprise camera systems that cost $50,000+ per year — 
            giving them a huge advantage in visibility and decision-making.
          </p>
          <div className="bg-red-50 border-l-4 border-red-500 p-6 mt-8 rounded-r-lg">
            <p className="text-xl font-semibold text-red-800">
              Result? Smaller businesses make staffing and marketing decisions in the dark.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProblemSection